module.exports = __webpack_public_path__ + "img/kexiangzhengfubutie_image_zc.47a3c646.png";